export default __webpack_public_path__ + "static/media/8aac5d38-8e50-4940-8cd1-ac406f070279.11329ce7.ttf";